/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendNotification.defs'
export { main as default } from './sendNotification.defs'
